export const AI_AUTOPILOT_USER_ID = "6751fa4d22d10a973cdd199a";
export const CHATBOT_USER_ID = "65e7517b0b80d02c14477940";
export const ATTENTIVE_OUTBOUND_USER_ID = "66ccddb4fe6fe6bd90f05b30";
export const ANONYMOUS_USER_ID = "66566f0d1942cbc64087e83f";
export const PRICING_TABLE_ID = "69091cd2f9a21cd78b15cd28"; // pricing table as of 11/03/25

export const REDO_LOCAL_STORAGE_KEY_OPEN = "redo_widget_open";
export const NUM_FREE_TRIAL_CREDITS = 25;
export const TEMP_ID = "temp";
